import Echo from "laravel-echo";
import Pusher from "pusher-js";

window.Pusher = Pusher;

const echo = new Echo({
  broadcaster: "reverb",
  key: process.env.VUE_APP_REVERB_APP_KEY,
  wsHost: process.env.VUE_APP_REVERB_HOST || "missingcall.bignerds.dev",
  wsPort: process.env.VUE_APP_REVERB_PORT || 6001,
  wssPort: process.env.VUE_APP_REVERB_PORT || 6001, // Añade wssPort para conexiones seguras
  forceTLS: true, // Cambia a true para forzar wss://
  enabledTransports: ["ws", "wss"], // Habilita ambos transportes, pero prioriza wss
  disableStats: true,
});

export default echo;